// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/Kinder_in_Indonesien.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SurveyFull_pictureBackground__wGszJ {
  width: 100%;
  height: auto;
}
@media (min-width: 1540px) {
  .SurveyFull_pictureBackground__wGszJ {
    padding-left: 120px;
  }
}
@media (min-width: 1700px) {
  .SurveyFull_pictureBackground__wGszJ {
    padding-left: calc(120px + 0.5 * (100vw - 1700px));
  }
}
.SurveyFull_pictureBackground__wGszJ {
  background-image: url(https://res.cloudinary.com/croative/image/upload/v1666945086/benchmark/logo-220x220.png), radial-gradient(circle at center, rgba(255, 255, 255, 0.6) 70%, transparent 30%), url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 10px bottom 10px, right 7px bottom 7px, center;
  background-repeat: no-repeat, no-repeat, no-repeat;
  background-size: 80px, 88px 88px, cover;
  color: #ffffff;
  text-align: left;
  padding: 100px 0 80px 100px;
}
.SurveyFull_pictureBackground__wGszJ h1 {
  font-family: "Barlow", Helvetica, sans-serif;
  font-size: 3.3rem;
  font-weight: 700;
  text-transform: none;
  text-shadow: 0px 0px 8px black;
}
.SurveyFull_pictureBackground__wGszJ h1 span {
  text-transform: capitalize;
}
.SurveyFull_pictureBackground__wGszJ p {
  width: 75%;
  max-width: 1300px;
  font-family: "Barlow", Helvetica, sans-serif;
  font-weight: 400;
  font-size: 22px;
  line-height: 32px;
  letter-spacing: 0.02em;
  white-space: pre-wrap;
  background-color: rgba(56, 57, 55, 0.6);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px); /* Safari */
  border-radius: 10px;
  padding: 5px 5px 5px 10px;
}
.SurveyFull_pictureBackground__wGszJ .SurveyFull_formEntry__XGYn3 {
  margin-bottom: 20px;
  border-radius: 0;
  font-family: "Barlow", Helvetica, sans-serif;
  font-size: 22px;
}
.SurveyFull_pictureBackground__wGszJ .SurveyFull_buttons__EnukT {
  margin-top: 50px;
  font-family: "Barlow", Helvetica, sans-serif;
  font-size: 22px;
  line-height: 30px;
}
.SurveyFull_pictureBackground__wGszJ .SurveyFull_headerBtn__IF27I {
  font-family: "Barlow", Helvetica, sans-serif;
  padding: 15px 30px;
  background-color: #f2994a;
  border: solid #f2994a 2px;
  color: #ffffff;
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-align: center;
  font-size: 20px;
}
.SurveyFull_pictureBackground__wGszJ .SurveyFull_headerBtn__IF27I:hover {
  background-color: #b06f35;
  border: solid #ffffff 2px;
}
.SurveyFull_pictureBackground__wGszJ .SurveyFull_secondBtn__MV8H8 {
  font-family: "Barlow", Helvetica, sans-serif;
  padding: 15px 30px;
  background: none;
  border: solid #ffffff 2px;
  color: #ffffff;
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-align: center;
}
.SurveyFull_pictureBackground__wGszJ .SurveyFull_secondBtn__MV8H8:hover {
  background-color: #000;
  border: solid #aaaaaa 2px;
}
.SurveyFull_pictureBackground__wGszJ h1 {
  line-height: 84px;
  letter-spacing: 0.02em;
}

.SurveyFull_mainContent__Kzws2 {
  padding-top: 100px;
  margin-left: auto;
  margin-right: auto;
  font-family: "Barlow", Helvetica, sans-serif;
}
.SurveyFull_mainContent__Kzws2 p {
  font-size: 22px;
}
@media (max-width: 991px) {
  .SurveyFull_mainContent__Kzws2 {
    max-width: 92% !important;
  }
}

.SurveyFull_list__pTdaz {
  text-align: left;
}

.SurveyFull_orgLabel__Fjn6l {
  margin-top: -20px;
  color: #8a8787;
  text-transform: uppercase;
  font-weight: 400;
  font-size: 1.4rem;
  line-height: 36px;
  letter-spacing: 0.02em;
}
@media (min-width: 750px) {
  .SurveyFull_orgLabel__Fjn6l {
    font-size: 1.8rem;
  }
}

.SurveyFull_orgName__R\\+yU2 {
  font-weight: 400;
  font-size: 1.8rem;
  line-height: 48px;
  letter-spacing: 0.02em;
}
@media (min-width: 750px) {
  .SurveyFull_orgName__R\\+yU2 {
    font-size: 2.5rem;
  }
}

.SurveyFull_editDiv__jVz8t {
  margin-top: -80px;
  margin-left: auto;
  margin-right: 0;
  text-transform: uppercase;
  color: #8a8787;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.SurveyFull_editText__2BEg4 {
  font-weight: 600;
  font-size: 20px;
  line-height: 31px;
  letter-spacing: 0.02em;
}

.SurveyFull_hr__K-qS9 {
  margin: 50px 0;
  border: 1px solid #cbc8c8;
}

.SurveyFull_infoContainer__EWOkn, .SurveyFull_nextDateContainer__frDwD {
  border: 1px solid #cbc8c8;
  margin-bottom: 30px;
  padding: 50px;
  text-align: left;
}

.SurveyFull_nextDateContainer__frDwD {
  border-color: rgb(190, 16, 32);
  padding-top: 30px;
  padding-bottom: 25px;
}

.SurveyFull_infoText__839WW {
  font-family: "Barlow", Helvetica, sans-serif;
  font-weight: 300;
  line-height: 35px;
  letter-spacing: 0.02em;
  white-space: pre-wrap;
}
.SurveyFull_infoText__839WW .SurveyFull_attention__yvi8P {
  font-weight: 600;
  text-decoration: underline;
}
.SurveyFull_infoText__839WW .SurveyFull_fwNormal__rKmHO {
  font-weight: 400;
}
.SurveyFull_infoText__839WW .SurveyFull_fwBold__hItal {
  font-weight: 600;
}

.SurveyFull_secondBtn__MV8H8 {
  font-family: "Barlow", Helvetica, sans-serif;
  padding: 15px 30px;
  background: none;
  border: solid #ffffff 2px;
  color: #ffffff;
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-align: center;
}
.SurveyFull_secondBtn__MV8H8:hover {
  background-color: #000;
  border: solid #aaaaaa 2px;
}
.SurveyFull_secondBtn__MV8H8 {
  height: 65px;
  font-size: 20px;
  background-color: rgba(56, 57, 55, 0.6);
  border: solid rgba(56, 57, 55, 0.6) 2px;
}

.SurveyFull_image__gOzBf {
  margin: 10px auto 40px;
  width: 100%;
  max-width: 1500px;
  border: solid rgba(56, 57, 55, 0.6) 2px;
  border-radius: 5px;
}

.SurveyFull_linkContainer__neQ1i {
  margin-bottom: 30px;
  font-family: "Barlow", Helvetica, sans-serif;
}

.SurveyFull_surveyStatus__L9Hg-, .SurveyFull_vSurveyStatus__tfDjv {
  opacity: 0.6;
  font-size: 1.8rem;
}
@media (min-width: 750px) {
  .SurveyFull_surveyStatus__L9Hg-, .SurveyFull_vSurveyStatus__tfDjv {
    font-size: 2.5rem;
  }
}
@media (min-width: 992px) {
  .SurveyFull_surveyStatus__L9Hg-, .SurveyFull_vSurveyStatus__tfDjv {
    font-size: 3.3rem;
  }
}

.SurveyFull_filledOut__\\+AzU9 {
  opacity: 0.6;
  text-transform: uppercase;
  font-size: 14px;
}
@media (min-width: 992px) {
  .SurveyFull_filledOut__\\+AzU9 {
    font-size: 16px;
  }
}

.SurveyFull_surveysFinished__oABZz {
  margin-top: 5px;
  opacity: 0.6;
  font-size: 14px;
}

.SurveyFull_subTitle__HUGgN {
  opacity: 0.6;
  white-space: pre-wrap;
}

.SurveyFull_smallEditIcon__XHRsC {
  height: 50px;
}

.SurveyFull_tinyEditIcon__aNQ9d {
  width: 35px;
  height: 35px;
  fill: #8a8787;
}

.SurveyFull_editFinishedModule__owMnC {
  text-align: center;
}
.SurveyFull_editFinishedModule__owMnC:hover {
  background-color: #f2f2f2;
}

.SurveyFull_smallEditText__-xGt5, .SurveyFull_tinyEditText__Bm7O2, .SurveyFull_statisticsText__22wFp, .SurveyFull_startNowText__hxb64, .SurveyFull_continueText__GgU5U {
  font-weight: 600;
  font-size: 16px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}
@media (min-width: 780px) {
  .SurveyFull_smallEditText__-xGt5, .SurveyFull_tinyEditText__Bm7O2, .SurveyFull_statisticsText__22wFp, .SurveyFull_startNowText__hxb64, .SurveyFull_continueText__GgU5U {
    font-size: 20px;
  }
}

.SurveyFull_tinyEditText__Bm7O2 {
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 0;
  color: #8a8787;
  margin-left: -4px;
}
.SurveyFull_tinyEditText__Bm7O2:hover {
  background-color: #f2f2f2;
}

.SurveyFull_statisticsIcon__0e9hM {
  height: 50px;
  fill: #6fcf97;
}

.SurveyFull_rocketIcon__H94Ei {
  height: 50px;
  fill: #f2994a;
}

.SurveyFull_statisticsText__22wFp, .SurveyFull_startNowText__hxb64, .SurveyFull_continueText__GgU5U {
  text-transform: none;
  color: #6fcf97;
}

.SurveyFull_startNowText__hxb64, .SurveyFull_continueText__GgU5U {
  color: #f2994a;
  white-space: nowrap;
}

.SurveyFull_bottomContainer__dmM7U {
  border: 1px solid #cbc8c8;
  margin-bottom: 100px;
  padding: 50px;
  text-align: left;
}

.SurveyFull_closeSurveyTitle__mgXcD {
  margin-top: 20px;
  font-family: "Barlow", Helvetica, sans-serif;
  font-weight: 500;
  font-size: 40px;
  letter-spacing: 0.02em;
  text-transform: none;
}

.SurveyFull_closeSurveyBtn__FLq2L {
  margin-top: 20px;
  font-family: "Barlow", Helvetica, sans-serif;
  font-weight: 600;
  font-size: 22px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  cursor: pointer;
  background-color: #ffffff;
  border: 1px solid #000;
  padding: 15px 30px;
}
.SurveyFull_closeSurveyBtn__FLq2L:hover {
  background-color: #f2f2f2;
}

.SurveyFull_rightChevron__rDgFJ {
  height: 25px;
  margin: -2px -5px 0 20px;
}

.SurveyFull_verticalSection__mfmZ7 {
  margin-left: 0px !important;
  width: 103%;
}

.SurveyFull_verticalItem__Popn7 {
  padding: 10px;
  width: 22% !important;
  margin-right: 3%;
  text-align: center !important;
  height: 620px;
}
@media (min-width: 780px) {
  .SurveyFull_verticalItem__Popn7 {
    padding: 20px;
  }
}
@media (min-width: 992px) {
  .SurveyFull_verticalItem__Popn7 {
    height: 550px;
  }
}
@media (min-width: 1200px) {
  .SurveyFull_verticalItem__Popn7 {
    height: 510px;
  }
}

.SurveyFull_vSurveyStatus__tfDjv, .SurveyFull_vMinutes__6T4wo {
  opacity: 0.8;
  margin-bottom: 0;
}

.SurveyFull_vMinutes__6T4wo {
  font-size: 14px;
}

.SurveyFull_vTitleContainer__HcdFw {
  height: 210px;
}
@media (min-width: 992px) {
  .SurveyFull_vTitleContainer__HcdFw {
    height: 170px;
  }
}
@media (min-width: 1200px) {
  .SurveyFull_vTitleContainer__HcdFw {
    height: 130px;
  }
}

.SurveyFull_vTitle__8wx9I {
  text-transform: none;
  overflow-wrap: break-word;
  word-break: break-word;
  hyphens: auto;
  margin-bottom: 0;
}
@media (max-width: 740px) {
  .SurveyFull_vTitle__8wx9I {
    font-size: 1.4rem;
  }
}

.SurveyFull_vEditContainer__S6IpC {
  padding: 10px;
  height: 80px;
}

.SurveyFull_vEditContainer2__tLwq8:hover {
  background-color: #f2f2f2;
}

.SurveyFull_vMainIconContainer__F21LB {
  padding: 10px;
  height: 120px;
}

.SurveyFull_horizontalLine__-VrmU {
  margin: 10px 10vw;
  width: 80%;
  text-align: center;
  border-bottom: 1px solid #aaaaaa;
  line-height: 0.1em;
  margin: 10px;
  width: 86%;
}`, "",{"version":3,"sources":["webpack://./src/components/SurveyFull/SurveyFull.module.scss","webpack://./src/styles/_mixins.scss","webpack://./src/styles/_colors.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAIA;ECAE,WAAA;EACA,YAAA;ADFF;ACGE;EDFF;ICGI,mBAAA;EDAF;AACF;ACCE;EDLF;ICMI,kDAAA;EDEF;AACF;AATA;ECUE,yOAAA;EAOA,yEAAA;EAGA,kDAAA;EAGA,uCAAA;EAIA,cCLY;EDMZ,gBAAA;EACA,2BAAA;ADXF;ACYE;EACE,4CEXS;EFYT,iBE/BI;EFgCJ,gBAAA;EACA,oBAAA;EACA,8BAAA;ADVJ;ACYI;EACE,0BAAA;ADVN;ACaE;EACE,UAAA;EACA,iBAAA;EACA,4CEvBW;EFwBX,gBAAA;EACA,eEtCM;EFuCN,iBAAA;EACA,sBAAA;EACA,qBAAA;EAEA,uCCpBqC;EDqBrC,0BAAA;EACA,kCAAA,EAAA,WAAA;EACA,mBAAA;EACA,yBAAA;ADZJ;ACcE;EAuBA,mBAAA;EACA,gBAAA;EACA,4CE7Da;EF8Db,eE3EQ;AHyCV;ACWE;EACE,gBAAA;EACA,4CEzCW;EF0CX,eEvDM;EFwDN,iBAAA;ADTJ;ACWE;EAqBA,4CEnEW;EFoEX,kBAAA;EACA,yBC7Ec;ED8Ed,yBAAA;EACA,cCrEY;EDsEZ,yBAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eEvFS;AH0DX;AC8BE;EACE,yBCrFkB;EDsFlB,yBAAA;AD5BJ;ACFE;EAmCA,4CEpFW;EFqFX,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,cCtFY;EDuFZ,yBAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;AD9BF;AC+BE;EACE,sBC9GU;ED+GV,yBAAA;AD7BJ;AApFE;EACE,iBAAA;EACA,sBAAA;AAsFJ;;AAlFA;ECiSE,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,4CExRW;AH6Eb;AC4ME;EACE,eEtSM;AH4FV;AA1FE;EAFF;IAGI,yBAAA;EA6FF;AACF;;AA1FA;EACE,gBAAA;AA6FF;;AAzFA;EACE,iBAAA;EACA,cEXU;EFYV,yBAAA;EACA,gBGTU;EHUV,iBGrBM;EHsBN,iBAAA;EACA,sBAAA;AA4FF;AA3FE;EARF;IASI,iBG1BI;EHwHN;AACF;;AA5FA;EACE,gBGlBU;EHmBV,iBG/BM;EHgCN,iBAAA;EACA,sBAAA;AA+FF;AA9FE;EALF;IAMI,iBGpCU;EHqIZ;AACF;;AA/FA;EACE,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,cEnCU;EFoCV,eAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAkGF;;AAhGA;EACE,gBGpCa;EHqCb,eG7CS;EH8CT,iBAAA;EACA,sBAAA;AAmGF;;AAjGA;EACE,cAAA;EACA,yBAAA;AAoGF;;AAjGA;EACE,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;AAoGF;;AAjGA;EACE,8BEnCe;EFoCf,iBAAA;EACA,oBAAA;AAoGF;;AAjGA;EACE,4CGxDa;EHyDb,gBGhES;EHiET,iBAAA;EACA,sBAAA;EACA,qBAAA;AAoGF;AAlGE;EACE,gBGnEW;EHoEX,0BAAA;AAoGJ;AAjGE;EACE,gBG1EQ;AH6KZ;AAhGE;EACE,gBG5EW;AH8Kf;;AA9FA;ECOE,4CEpFW;EFqFX,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,cCtFY;EDuFZ,yBAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;AD2FF;AC1FE;EACE,sBC9GU;ED+GV,yBAAA;AD4FJ;AA9GA;EAEE,YAAA;EACA,eG3FS;EH4FT,uCEtEuC;EFuEvC,uCAAA;AA+GF;;AA5GA;EACE,sBAAA;EACA,WAAA;EACA,iBAAA;EACA,uCAAA;EACA,kBAAA;AA+GF;;AA5GA;EACE,mBAAA;EACA,4CG/FW;AH8Mb;;AA5GA;EACE,YAAA;EACA,iBGrHM;AHoOR;AA9GE;EAHF;IAII,iBGxHU;EHyOZ;AACF;AAhHE;EANF;IAOI,iBG5HI;EH+ON;AACF;;AAhHA;EACE,YAAA;EACA,yBAAA;EACA,eGzHc;AH4OhB;AAlHE;EAJF;IAKI,eG5HO;EHiPT;AACF;;AAlHA;EACE,eAAA;EACA,YAAA;EACA,eGlIc;AHuPhB;;AAlHA;EACE,YAAA;EACA,qBAAA;AAqHF;;AAlHA;EACE,YAAA;AAqHF;;AAlHA;EACE,WAAA;EACA,YAAA;EACA,aEjJU;AFsQZ;;AAlHA;EACE,kBAAA;AAqHF;AApHE;EACE,yBE5JmB;AFkRvB;;AAlHA;EACE,gBGtJa;EHuJb,eG9JS;EH+JT,sBAAA;EACA,yBAAA;AAqHF;AApHE;EALF;IAMI,eGnKO;EH0RT;AACF;;AApHA;EACE,gBGjKU;EHkKV,eGvKc;EHwKd,iBAAA;EACA,cEzKU;EF0KV,iBAAA;AAuHF;AAtHE;EACE,yBEjLmB;AFySvB;;AApHA;EACE,YAAA;EACA,aE/KW;AFsSb;;AApHA;EACE,YAAA;EACA,aEtLc;AF6ShB;;AApHA;EACE,oBAAA;EACA,cEzLW;AFgTb;;AApHA;EACE,cE/Lc;EFgMd,mBAAA;AAuHF;;AApHA;EACE,yBAAA;EACA,oBAAA;EACA,aAAA;EACA,gBAAA;AAuHF;;AApHA;EACE,gBAAA;EACA,4CGpMW;EHqMX,gBGzMU;EH0MV,eGnNgB;EHoNhB,sBAAA;EACA,oBAAA;AAuHF;;AApHA;EACE,gBAAA;EACA,4CG7MW;EH8MX,gBGjNa;EHkNb,eG3NQ;EH4NR,sBAAA;EACA,yBAAA;EACA,eAAA;EACA,yBEjNY;EFkNZ,sBAAA;EACA,kBAAA;AAuHF;AAtHE;EACE,yBErOmB;AF6VvB;;AApHA;EACE,YAAA;EACA,wBAAA;AAuHF;;AApHA;EACE,2BAAA;EAEA,WAAA;AAsHF;;AAnHA;EACE,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,6BAAA;EACA,aAAA;AAsHF;AArHE;EANF;IAOI,aAAA;EAwHF;AACF;AAvHE;EATF;IAUI,aAAA;EA0HF;AACF;AAzHE;EAZF;IAaI,aAAA;EA4HF;AACF;;AAzHA;EACE,YAAA;EACA,gBAAA;AA4HF;;AAzHA;EACE,eGtQc;AHkYhB;;AAzHA;EACE,aAAA;AA4HF;AA3HE;EAFF;IAGI,aAAA;EA8HF;AACF;AA7HE;EALF;IAMI,aAAA;EAgIF;AACF;;AA7HA;EACE,oBAAA;EACA,yBAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;AAgIF;AA/HE;EANF;IAOI,iBGjSI;EHmaN;AACF;;AA/HA;EACE,aAAA;EACA,YAAA;AAkIF;;AA9HE;EACE,yBE1SmB;AF2avB;;AA7HA;EACE,aAAA;EACA,aAAA;AAgIF;;AA7HA;EChEE,iBAAA;EACA,UAAA;EACA,kBAAA;EACA,gCAAA;EACA,kBAAA;ED8DA,YAAA;EACA,UAAA;AAoIF","sourcesContent":["@import '../../styles/colors';\n@import \"../../styles/mixins\";\n@import '../../styles/variables';\n\n.pictureBackground {\n  @include picture-background('../assets/images/Kinder_in_Indonesien.png');\n  h1 {\n    line-height: 84px;\n    letter-spacing: 0.02em;\n  }\n}\n\n.mainContent {\n  @include main-content-container;\n  @media (max-width: 991px) {\n    max-width: 92% !important;\n  }\n}\n\n.list {\n  text-align: left;\n  // margin: 0 20px 15px;\n}\n\n.orgLabel {\n  margin-top: -20px;\n  color: $gray-text;\n  text-transform: uppercase;\n  font-weight: $fw-normal;\n  font-size: $fs-h3;\n  line-height: 36px;\n  letter-spacing: 0.02em;\n  @media (min-width: 750px) {\n    font-size: $fs-h2;\n  }\n}\n.orgName {\n  font-weight: $fw-normal;\n  font-size: $fs-h2;\n  line-height: 48px;\n  letter-spacing: 0.02em;\n  @media (min-width: 750px) {\n    font-size: $fs-h2-large;\n  }\n}\n.editDiv {\n  margin-top: -80px;\n  margin-left: auto;\n  margin-right: 0;\n  text-transform: uppercase;\n  color: $gray-text;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.editText {\n  font-weight: $fw-semi-bold;\n  font-size: $fs-label;\n  line-height: 31px;\n  letter-spacing: 0.02em;\n}\n.hr {\n  margin: 50px 0;\n  border: 1px solid $light-gray-lines;\n}\n\n.infoContainer, .nextDateContainer {\n  border: 1px solid $light-gray-lines;\n  margin-bottom: 30px;\n  padding: 50px;\n  text-align: left;\n}\n\n.nextDateContainer {\n  border-color: $bench-logo-red;\n  padding-top: 30px;\n  padding-bottom: 25px;\n}\n\n.infoText {\n  font-family: $ff-secondary;\n  font-weight: $fw-light;\n  line-height: 35px;\n  letter-spacing: 0.02em;\n  white-space: pre-wrap;\n\n  .attention {\n    font-weight: $fw-semi-bold;\n    text-decoration: underline;\n  }\n\n  .fwNormal {\n    font-weight: $fw-normal;\n  }\n\n  .fwBold {\n    font-weight: $fw-semi-bold;\n  }\n}\n\n.secondBtn {\n  @include second-button;\n  height: 65px;\n  font-size: $fs-label;\n  background-color: $bench-logo-anthracite-semi-transparent;\n  border: solid $bench-logo-anthracite-semi-transparent 2px;\n}\n\n.image {\n  margin: 10px auto 40px;\n  width: 100%;\n  max-width: 1500px;\n  border: solid $bench-logo-anthracite-semi-transparent 2px;\n  border-radius: 5px;\n}\n\n.linkContainer {\n  margin-bottom: 30px;\n  font-family: $ff-primary;\n}\n\n.surveyStatus, .vSurveyStatus {\n  opacity: 0.6;\n  font-size: $fs-h2;\n  @media (min-width: 750px) {\n    font-size: $fs-h2-large;\n  }\n  @media (min-width: 992px) {\n    font-size: $fs-h1;\n  }\n}\n\n.filledOut {\n  opacity: 0.6;\n  text-transform: uppercase;\n  font-size: $fs-very-small;\n  @media (min-width: 992px) {\n    font-size: $fs-small;\n  }\n}\n\n.surveysFinished {\n  margin-top: 5px;\n  opacity: 0.6;\n  font-size: $fs-very-small;\n}\n\n.subTitle {\n  opacity: 0.6;\n  white-space: pre-wrap;\n}\n\n.smallEditIcon {\n  height: 50px;\n}\n\n.tinyEditIcon {\n  width: 35px;\n  height: 35px;\n  fill: $gray-text;\n}\n\n.editFinishedModule {\n  text-align: center;\n  &:hover {\n    background-color: $gray-card-background;\n  }\n}\n\n.smallEditText, .tinyEditText, .statisticsText, .startNowText, .continueText {\n  font-weight: $fw-semi-bold;\n  font-size: $fs-small;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  @media (min-width: 780px) {\n    font-size: $fs-label;\n  }\n}\n\n.tinyEditText {\n  font-weight: $fw-medium;\n  font-size: $fs-very-small;\n  letter-spacing: 0;\n  color: $gray-text;\n  margin-left: -4px;\n  &:hover {\n    background-color: $gray-card-background;\n  }\n}\n\n.statisticsIcon {\n  height: 50px;\n  fill: $green-icon;\n}\n\n.rocketIcon {\n  height: 50px;\n  fill: $orange-button;\n}\n\n.statisticsText, .startNowText, .continueText {\n  text-transform: none;\n  color: $green-icon;\n}\n\n.startNowText, .continueText {\n  color: $orange-button;\n  white-space: nowrap;\n}\n\n.bottomContainer {\n  border: 1px solid $light-gray-lines;\n  margin-bottom: 100px;\n  padding: 50px;\n  text-align: left;\n}\n\n.closeSurveyTitle {\n  margin-top: 20px;\n  font-family: $ff-primary;\n  font-weight: $fw-medium;\n  font-size: $fs-sectionTitle;\n  letter-spacing: 0.02em;\n  text-transform: none;\n}\n\n.closeSurveyBtn {\n  margin-top: 20px;\n  font-family: $ff-primary;\n  font-weight: $fw-semi-bold;\n  font-size: $fs-body;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  cursor: pointer;\n  background-color: $white-color;\n  border: 1px solid $black-color;\n  padding: 15px 30px;\n  &:hover {\n    background-color: $gray-card-background;\n  }\n}\n\n.rightChevron {\n  height: 25px;\n  margin: -2px -5px 0 20px;\n}\n\n.verticalSection {\n  margin-left: 0px !important;\n  //margin-left: 15px !important;\n  width: 103%; // tweak width to avoid bootstrap moving last element down to next line\n}\n\n.verticalItem {\n  padding: 10px;\n  width: 22% !important; // override bootstrap's list-group-item-action\n  margin-right: 3%;\n  text-align: center !important;\n  height: 620px;\n  @media (min-width: 780px) {\n    padding: 20px;\n  }\n  @media (min-width: 992px) {\n    height: 550px;\n  }\n  @media (min-width: 1200px) {\n    height: 510px;\n  }\n}\n\n.vSurveyStatus, .vMinutes {\n  opacity: 0.8;\n  margin-bottom: 0;\n}\n\n.vMinutes {\n  font-size: $fs-very-small;\n}\n\n.vTitleContainer {\n  height: 210px;\n  @media (min-width: 992px) {\n    height: 170px;\n  }\n  @media (min-width: 1200px) {\n    height: 130px;\n  }\n}\n\n.vTitle {\n  text-transform: none;\n  overflow-wrap: break-word;\n  word-break: break-word;\n  hyphens: auto;\n  margin-bottom: 0;\n  @media (max-width: 740px) {\n    font-size: $fs-h3;\n  }\n}\n\n.vEditContainer {\n  padding: 10px;\n  height: 80px;\n}\n\n.vEditContainer2 {\n  &:hover {\n    background-color: $gray-card-background;\n  }\n}\n\n.vMainIconContainer {\n  padding: 10px;\n  height: 120px;\n}\n\n.horizontalLine {\n  @include horizontal-line;\n  margin: 10px;\n  width: 86%;\n}\n","@import \"./colors\";\n@import \"./variables\";\n\n@mixin picture-background($image-url: '../assets/images/PluSport_VMI_red.jpeg') {\n  width: 100%;\n  height: auto;\n  @media (min-width: 1540px) {\n    padding-left: 120px;\n  }\n  @media (min-width: 1700px) {\n    padding-left: calc(120px + 0.5 * (100vw - 1700px));\n  }\n\n  //background: url($image-url) 0 0 / cover;\n  background-image: url(#{$logo-url}), // Top: logo\n  radial-gradient(\n                  circle at center,\n                  rgba(255, 255, 255, 0.6) 70%, // radius of the white portion -> disc\n                  transparent 30% // point beyond which the white is no longer visible -> remove corners of square shape\n  ),\n  url(#{$image-url}); // Bottom: main image\n  background-position: right 10px bottom 10px, // Logo position\n  right 7px bottom 7px, // Disc position (same as logo)\n  center; // Main image position\n  background-repeat: no-repeat,\n  no-repeat,\n  no-repeat;\n  background-size: 80px, // Logo size\n  88px 88px, // size of square for the white disc (slightly bigger than logo)\n  cover; // Main background image fills the area\n\n  color: $white-color;\n  text-align: left;\n  padding: 100px 0 80px 100px;\n  h1 {\n    font-family: $ff-primary;\n    font-size: $fs-h1;\n    font-weight: 700;\n    text-transform: none;\n    text-shadow: 0px 0px 8px black;\n\n    span {\n      text-transform: capitalize;\n    }\n  }\n  p {\n    width: 75%;\n    max-width: 1300px;\n    font-family: $ff-secondary;\n    font-weight: 400;\n    font-size: $fs-body;\n    line-height: 32px;\n    letter-spacing: 0.02em;\n    white-space: pre-wrap;\n    //text-shadow: 0px 0px 5px black;\n    background-color: $bench-logo-anthracite-semi-transparent;\n    backdrop-filter: blur(4px);\n    -webkit-backdrop-filter: blur(4px); /* Safari */\n    border-radius: 10px;\n    padding: 5px 5px 5px 10px;\n  }\n  .formEntry {\n    @include form-entry;\n  }\n  .buttons {\n    margin-top: 50px;\n    font-family: $ff-secondary;\n    font-size: $fs-body;\n    line-height: 30px;\n  }\n  .headerBtn {\n    @include main-button;\n  }\n  .secondBtn {\n    @include second-button;\n  }\n}\n\n@mixin form-label {\n  text-align: left;\n  font-family: $ff-primary;\n  font-size: $fs-body;\n}\n@mixin form-entry {\n  margin-bottom: 20px;\n  border-radius: 0;\n  font-family: $ff-secondary;\n  font-size: $fs-body;\n}\n\n@mixin main-button {\n  font-family: $ff-primary;\n  padding: 15px 30px;\n  background-color: $orange-button;\n  border: solid $orange-button 2px;\n  color: $white-color;\n  text-transform: uppercase;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  text-align: center;\n  font-size: $fs-label;\n  &:hover {\n    background-color: $orange-button-hover;\n    border: solid $white-color 2px;\n  }\n}\n\n@mixin second-button {\n  font-family: $ff-primary;\n  padding: 15px 30px;\n  background: none;\n  border: solid $white-color 2px;\n  color: $white-color;\n  text-transform: uppercase;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  text-align: center;\n  &:hover {\n    background-color: $black-color;\n    border: solid $gray-color 2px;\n  }\n}\n\n@mixin module-header {\n  margin: 70px 0 8px;\n  font-family: $ff-primary;\n  font-size: $fs-h4;\n  font-weight: $fw-normal;\n  text-transform: uppercase;\n}\n\n@mixin survey-container {\n  margin-bottom: 100px;\n  font-family: $ff-primary;\n}\n\n@mixin survey-question {\n  margin-top: 40px;\n  color: $gray-text;\n  font-family: $ff-secondary;\n  font-size: $fs-h3;\n  font-weight: $fw-normal;\n  line-height: 1.1;\n  white-space: pre-wrap;\n  @media (min-width: 1400px) {\n    margin-left: auto;\n    margin-right: auto;\n    max-width: 1120px;\n  }\n}\n\n@mixin survey-toggle-buttons {\n  align-items: center;\n  gap: 10px;\n  grid-auto-flow: column;\n  grid-auto-columns: 30vw;\n  display: inline-grid !important;\n  max-width: 700px;\n  @media (min-width: 1150px) {\n    grid-auto-columns: 350px;\n  }\n}\n\n@mixin survey-radios {\n  background-color: $white-color;\n  border-style: solid;\n  border-width: 3px;\n  height: 25px;\n  width: 25px;\n  &:hover {\n    background-color: $gray-answer-circle-color;\n    box-shadow: 0 0 3px $accent_color;\n  }\n}\n\n@mixin survey-radio-answer {\n  display: block;\n  text-align: left;\n  margin-top: -5px;\n  margin-left: 35px;\n  width: auto;\n  min-width: 200px;\n  color: $gray-text;\n  font-size: $fs-h4;\n  font-family: $ff-secondary;\n  line-height: 1.1;\n  @media (min-width: 900px) {\n    min-width: 250px;\n  }\n  @media (min-width: 1100px) {\n    min-width: 280px;\n  }\n  @media (min-width: 1250px) {\n    min-width: 320px;\n  }\n  //@media (min-width: 1400px) {\n  //  min-width: 350px;\n  //}\n}\n\n@mixin right-arrow {\n  height: 21px;\n  width: auto;\n  margin-left: calc(160px + 12vw);\n  @media (min-width: 630px) {\n    margin-left: calc(250px - 5vw);\n  }\n  @media (min-width: 768px) {\n    margin-left: calc(300px - 3vw);\n  }\n  @media (min-width: 900px) {\n    margin-left: calc(305px - 4vw);\n  }\n  @media (min-width: 992px) {\n    margin-left: calc(410px - 4vw);\n  }\n  @media (min-width: 1200px) {\n    margin-left: calc(490px - 5vw);\n  }\n  @media (min-width: 1400px) {\n    margin-left: calc(560px - 5vw);\n  }\n}\n\n@mixin off-switch-type-C {\n  max-width: 30vw;\n  margin-top: 5px;\n  margin-left: 33%;\n  text-align: left;\n  color: $gray-text;\n  font-family: $ff-primary;\n  font-size: $fs-h4;\n  font-weight: $fw-normal;\n  @media (min-width: 990px) {\n    margin-left: 38%;\n  }\n  @media (min-width: 1200px) {\n    margin-left: 40%;\n  }\n}\n\n@mixin off-switch-type-D {\n  @include off-switch-type-C;\n  margin-left: 5%;\n  @media (min-width: 990px) {\n    margin-left: 10%;\n  }\n  @media (min-width: 1200px) {\n    margin-left: 18%;\n  }\n}\n\n@mixin horizontal-line {\n  margin: 10px 10vw;\n  width: 80%;\n  text-align: center;\n  border-bottom: 1px solid $gray-color;\n  line-height: 0.1em;\n}\n\n@mixin pagination-buttons {\n  margin-top: 20px;\n  margin-left: 20%;\n  width: 80%;\n  height: 40px;\n  color: $gray-color;\n  list-style: none;\n  display: flex;\n  @media (min-width: 990px) {\n    margin-left: 28%;\n  }\n  @media (min-width: 1200px) {\n    margin-left: 31%;\n  }\n  @media (min-width: 1400px) {\n    margin-left: 34%;\n  }\n  a {\n    padding: 5px;\n    margin: 8px;\n    border-radius: 5px;\n    border: 1px solid $gray-color;\n    text-decoration: none;\n    color: $gray-color;\n    cursor: pointer;\n    &:hover {\n      background-color: $gray-color;\n      color: $white-color;\n    }\n  }\n}\n\n@mixin pagination-active-button {\n  color: $white-color;\n  a {\n    background-color: $gray-color;\n    color: $white-color;\n  }\n}\n\n@mixin main-content-container {\n  padding-top: 100px;\n  margin-left: auto;\n  margin-right: auto;\n  font-family: $ff-primary;\n  p {\n    font-size: $fs-body;\n  }\n}\n\n@mixin main-container-title {\n  margin-bottom: 30px;\n  font-family: $ff-primary;\n  font-weight: 400;\n  font-size: 55px;\n  letter-spacing: 0.02em;\n  text-align: left;\n}\n","$red-strongly-disagree-color: #eb5757;\n$orange-disagree-color: #ef8400;\n$orange-somewhat-disagree-color: #efba00;\n$yellow-neutral-color: #ffe921;\n$lime-somewhat-agree-color: #dde041;\n$green-agree-color: #94c556;\n$green-strongly-agree-color: #56c568;\n$gray-answer-circle-color: #686b6f;\n$black-color: #000;\n$gray-color: #aaaaaa;\n$gray-card-background: #f2f2f2;\n$gray-card-border: #bdbdbd;\n$light-gray-input-background: rgba(229, 229, 229, 0.18);\n$gray-input-border: #d9d9d9;\n$light-gray-lines: #cbc8c8;\n$gray-text: #8a8787;\n$orange-button: #f2994a;\n$orange-button-hover: #b06f35;\n$green-icon: #6fcf97;\n$green-bootstrap-success: #198753;\n$test: rgb(150,150,150);\n\n// from Hvar Rentals:\n$dark-blue-color: #154c79;\n$dark-blue-hover-color: #2066a0;\n$light-blue-color: #e4eef7;\n$white-color: #ffffff;\n// $black-color: #000;\n// $gray-color: #aaaaaa;\n$light-gray-color: #eee;\n$red-error-color: #cf062e;\n$test-green-color: #0f7c0b;\n\n$accent_color: orange;\n$bench-logo-anthracite: rgba(56, 57, 55); // #383937 - we use rgba for react-charts\n$bench-logo-anthracite-semi-transparent: rgba(56, 57, 55, 0.6);\n$bench-logo-anthracite-low-transparent: rgba(56, 57, 55, 0.35);\n$bench-logo-blue: rgba(73, 177, 227); // #49B1E3\n$bench-logo-orange: rgba(241, 121, 2); // #F17902\n$bench-logo-orange-semi-transparent: rgba(241, 121, 2, 0.5); // #F17902\n$bench-logo-red: rgba(190, 16, 32); // #BE1020\n$bench-logo-yellow: rgba(254, 213, 0); // #FED500\n$kultivierer-orange: #D27F20;\n$vmi-logo-red: #A6192E;\n\n$EO-Gesamtmodell-red: rgb(255, 0, 0); // #FF0000\n$EO-Gesamtmodell-red-semi-transparent: rgb(255, 0, 0, 0.04); // #FF0000\n$EO-Gesamtmodell-red-active: rgb(255, 0, 0, 0.06); // #FF0000\n$EO-Gesamtmodell-green: rgb(51, 153, 51); // #339933\n$EO-Gesamtmodell-green-semi-transparent: rgb(51, 153, 51, 0.05); // #339933\n$EO-Gesamtmodell-green-active: rgb(51, 153, 51, 0.07); // #339933\n//$EO-Gesamtmodell-gray: rgb(128, 128, 128); // #808080\n//$EO-Gesamtmodell-gray-semi-transparent: rgb(128, 128, 128, 0.9); // #808080\n$EO-Gesamtmodell-black: rgb(0, 0, 0); // #000000\n$EO-Gesamtmodell-black-semi-transparent: rgb(0, 0, 0, 0.04); // #000000\n$EO-Gesamtmodell-black-active: rgb(0, 0, 0, 0.06); // #000000\n\n\n// Note: join two classNames together like this:\n// <div className={styles.container + ' ' + styles.containerActive} />\n","// LOGO URL\n$logo-url: 'https://res.cloudinary.com/croative/image/upload/v1666945086/benchmark/logo-220x220.png';\n// repeated in constants.js\n\n// FONT SIZES\n$fs-h1: 3.3rem;\n$fs-h2-large: 2.5rem;\n$fs-h2: 1.8rem;\n$fs-h3: 1.4rem;\n$fs-h4: 1.25rem;\n$fs-h5: 1.1rem;\n$fs-sectionTitle: 40px;\n$fs-body: 22px;\n$fs-label: 20px;\n$fs-small: 16px;\n$fs-very-small: 14px;\n\n// Font weights\n$fw-light: 300;\n$fw-normal: 400;\n$fw-medium: 500;\n$fw-semi-bold: 600;\n\n// Font Families\n$ff-primary: 'Barlow', Helvetica, sans-serif;\n$ff-secondary: 'Barlow', Helvetica, sans-serif;\n//$ff-secondary: 'Source Sans Pro', Helvetica, sans-serif;\n\n$max-width: 1420px;\n\n$answer-radio-grid-height: 60px;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pictureBackground": `SurveyFull_pictureBackground__wGszJ`,
	"formEntry": `SurveyFull_formEntry__XGYn3`,
	"buttons": `SurveyFull_buttons__EnukT`,
	"headerBtn": `SurveyFull_headerBtn__IF27I`,
	"secondBtn": `SurveyFull_secondBtn__MV8H8`,
	"mainContent": `SurveyFull_mainContent__Kzws2`,
	"list": `SurveyFull_list__pTdaz`,
	"orgLabel": `SurveyFull_orgLabel__Fjn6l`,
	"orgName": `SurveyFull_orgName__R+yU2`,
	"editDiv": `SurveyFull_editDiv__jVz8t`,
	"editText": `SurveyFull_editText__2BEg4`,
	"hr": `SurveyFull_hr__K-qS9`,
	"infoContainer": `SurveyFull_infoContainer__EWOkn`,
	"nextDateContainer": `SurveyFull_nextDateContainer__frDwD`,
	"infoText": `SurveyFull_infoText__839WW`,
	"attention": `SurveyFull_attention__yvi8P`,
	"fwNormal": `SurveyFull_fwNormal__rKmHO`,
	"fwBold": `SurveyFull_fwBold__hItal`,
	"image": `SurveyFull_image__gOzBf`,
	"linkContainer": `SurveyFull_linkContainer__neQ1i`,
	"surveyStatus": `SurveyFull_surveyStatus__L9Hg-`,
	"vSurveyStatus": `SurveyFull_vSurveyStatus__tfDjv`,
	"filledOut": `SurveyFull_filledOut__+AzU9`,
	"surveysFinished": `SurveyFull_surveysFinished__oABZz`,
	"subTitle": `SurveyFull_subTitle__HUGgN`,
	"smallEditIcon": `SurveyFull_smallEditIcon__XHRsC`,
	"tinyEditIcon": `SurveyFull_tinyEditIcon__aNQ9d`,
	"editFinishedModule": `SurveyFull_editFinishedModule__owMnC`,
	"smallEditText": `SurveyFull_smallEditText__-xGt5`,
	"tinyEditText": `SurveyFull_tinyEditText__Bm7O2`,
	"statisticsText": `SurveyFull_statisticsText__22wFp`,
	"startNowText": `SurveyFull_startNowText__hxb64`,
	"continueText": `SurveyFull_continueText__GgU5U`,
	"statisticsIcon": `SurveyFull_statisticsIcon__0e9hM`,
	"rocketIcon": `SurveyFull_rocketIcon__H94Ei`,
	"bottomContainer": `SurveyFull_bottomContainer__dmM7U`,
	"closeSurveyTitle": `SurveyFull_closeSurveyTitle__mgXcD`,
	"closeSurveyBtn": `SurveyFull_closeSurveyBtn__FLq2L`,
	"rightChevron": `SurveyFull_rightChevron__rDgFJ`,
	"verticalSection": `SurveyFull_verticalSection__mfmZ7`,
	"verticalItem": `SurveyFull_verticalItem__Popn7`,
	"vMinutes": `SurveyFull_vMinutes__6T4wo`,
	"vTitleContainer": `SurveyFull_vTitleContainer__HcdFw`,
	"vTitle": `SurveyFull_vTitle__8wx9I`,
	"vEditContainer": `SurveyFull_vEditContainer__S6IpC`,
	"vEditContainer2": `SurveyFull_vEditContainer2__tLwq8`,
	"vMainIconContainer": `SurveyFull_vMainIconContainer__F21LB`,
	"horizontalLine": `SurveyFull_horizontalLine__-VrmU`
};
export default ___CSS_LOADER_EXPORT___;
